var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"d-flex flex-wrap justify-center mx-2 my-4"},_vm._l((_vm.tutorials),function(tutorial){return _c('v-col',{key:tutorial.id,attrs:{"md":"4","sm":"12"}},[_c('VideoCard',{attrs:{"elementVideo":tutorial}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }